<ion-header [translucent]="true">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button [text]="'ZURUECK' | translate"></ion-back-button>
    </ion-buttons>
    <ion-title>{{ 'SCHADEN_MELDEN' | translate }}</ion-title>
    <ion-buttons slot="end">
      <ion-menu-button></ion-menu-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <div class="padding-16 flex flex-column gap-16">

    <!-- Fotos-Vorschau -->
    @if (capturedPhotos().length > 0) {
      <div class="photo-grid">
        @for (photo of capturedPhotos(); track photo.fileName; let i = $index) {
          <div class="photo-item">
            <img [src]="photo.dataUrl" [alt]="photo.fileName" class="photo-preview" />
            <work-ui-button
              (buttonClick)="removePhoto(i)"
              [iconOnly]="true"
              iconName="close"
              size="small"
              variant="secondary"
              class="photo-remove-btn" />
          </div>
        }
      </div>
    }

    <!-- Foto aufnehmen / Galerie -->
    <div class="flex gap-8">
      <work-ui-button
        (buttonClick)="takePhoto()"
        [disabled]="submitLoadingState() === 'loading'"
        [fullWidth]="true"
        iconName="photo_camera"
        text="FOTO_AUFNEHMEN"
        variant="secondary"
        class="flex-1" />
      <work-ui-button
        (buttonClick)="pickFromGallery()"
        [disabled]="submitLoadingState() === 'loading'"
        [fullWidth]="true"
        iconName="photo_library"
        text="GALLERIE"
        variant="secondary"
        class="flex-1" />
    </div>

    <!-- Notiz / Beschreibung -->
    <work-ui-input-field
      [formControl]="notesControl"
      label="SCHADEN_BESCHREIBUNG"
      variant="textarea" />

    <!-- Übermitteln -->
    <work-ui-button
      (buttonClick)="submit()"
      [(loadingState)]="submitLoadingState"
      [fullWidth]="true"
      iconName="warning"
      text="SCHADEN_UEBERMITTELN"
      variant="primary" />

  </div>
</ion-content>
